/** This script doesn't implement autoplay but rather checks if autoplay has
 * been disabled.
 *
 * Based on this post here:
 * https://webkit.org/blog/7734/auto-play-policy-changes-for-macos/
 *
 * Which was found from here:
 * https://caniuse.com/?search=video
 *
 */


/**
 * Initialise the lazy load module
 *
 * @param {string} selector
 */
export default function({
  playButtons = '.bg-video-play-button',
  fullScreenButtons = '.bg-video-fullscreen-button',
} = {}) {
  const playButtonEls = document.querySelectorAll(playButtons);
  const fullScreenButtonEls = document.querySelectorAll(fullScreenButtons);

  playButtonEls.forEach((element) => {
    const videoSelector = element.getAttribute('data-target');
    const video = document.querySelector(videoSelector);

    element.addEventListener('click', function(e) {
      e.preventDefault();
      togglePlay();
    });

    /**
     * Toggles the play button
     */
    function togglePlay() {
      if (video.paused || video.ended) {
        video.play().then(() => {
          element.classList.add('playing');
          element.classList.remove('paused');
        });
      } else {
        video.pause();
        if (video.paused) {
          element.classList.add('paused');
          element.classList.remove('playing');
        }
      }
    }

    const promise = video.play();

    let hasAutoplay = true;

    if (promise !== undefined) {
      promise.catch((error) => {
        // Auto-play was prevented
        // Show a UI element to let the user manually start playback

        hasAutoplay = false;
      }).then(() => {
        if (hasAutoplay) {
          element.classList.add('playing');
          element.classList.remove('paused');
        } else {
          element.classList.add('paused');
          element.classList.remove('playing');
        }
      });
    };
  });

  fullScreenButtonEls.forEach((element) => {
    const videoSelector = element.getAttribute('data-target');
    const video = document.querySelector(videoSelector + '-header');

    if (typeof element.requestFullscreen === 'function') {
      element.addEventListener('click', function(e) {
        e.preventDefault();
        const elem = video;

        if (!document.fullscreenElement) {
          elem.requestFullscreen().catch((err) => {
            console.log(`Error attempting to enable fullscreen mode: ${err.message} (${err.name})`);
          }).then(() => {
            element.classList.add('is-fullscreen');
          });
        } else {
          document.exitFullscreen().then(() => {
            element.classList.remove('is-fullscreen');
          });
        }
      });
    } else {
      element.classList.add('d-none');
    }
  });


  ['fullscreenchange',
    'webkitfullscreenchange',
    'mozfullscreenchange',
    'msfullscreenchange',
  ].forEach((eventType) => document.addEventListener(eventType, (e) => {
    if (!document.fullscreenElement) {
      console.log(document.fullscreenElement);
      // If we aren't in fullscreen any longer then remove classes

      const ela = document.querySelectorAll('.is-fullscreen');

      ela.forEach((item) => {
        item.classList.remove('is-fullscreen');
      });

      // const elb = document.querySelectorAll('.bg-video-fullscreen');

      // elb.forEach((item) => {
      //   item.classList.remove('bg-video-fullscreen');
      // });
    }
  }));
}
